module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-view"
  }, [_c('right-tabs', {
    attrs: {
      "redraw": _vm.redraw
    },
    on: {
      "close-details": function($event) {
        _vm.$emit('close-details')
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed576722"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/details-view.vue
// module id = 354
// module chunks = 1